import { Component, Input, OnInit, OnChanges, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BptProgressSpinnerMode, BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [BptProgressSpinnerModule, CommonModule],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnInit, OnChanges {
  @Input() useOverlay = false;
  @Input() message = "";
  animationDuration = "2 + 's'";  
  spinnerMode: BptProgressSpinnerMode = 'indeterminate';

  // Split message into primary and secondary for two-line display
  primaryMessage = "";
  secondaryMessage = "";

  constructor() { }

  ngOnInit(): void {
    this.splitMessage();
  }

  ngOnChanges(): void {
    this.splitMessage();
  }

  /**
   * Splits the message on the first period to create a two-line display
   * Primary: First sentence (bold, larger)
   * Secondary: Remaining text (lighter, smaller)
   */
  private splitMessage(): void {
    if (!this.message) {
      this.primaryMessage = "";
      this.secondaryMessage = "";
      return;
    }

    const firstPeriodIndex = this.message.indexOf('.');
    
    if (firstPeriodIndex !== -1 && firstPeriodIndex < this.message.length - 1) {
      // Split on first period
      this.primaryMessage = this.message.substring(0, firstPeriodIndex + 1).trim();
      this.secondaryMessage = this.message.substring(firstPeriodIndex + 1).trim();
    } else {
      // No period found or period is at the end - show as single message
      this.primaryMessage = this.message;
      this.secondaryMessage = "";
    }
  }
}

